import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './city-choose.scss';
import Color from '@tool/color';
import { CloseIcon20, DownFullIcon } from '@styled/icon';
import moCityRate from './store';
import moIndex, { toggleCityRate, toggleTip } from '../../store/index';
import moCityStore, { toggleModal } from './city-store';
import moUser from '@store/user';

interface IProps {}
interface IState {}

const DInputBase = styled(InputBase)(() => ({
  height: '30px',
  padding: '0 10px',
  borderRadius: '4px',
  lineHeight: 1,
  border: `1px solid ${Color.blackColor(0.1)}`,
}));

const CityChoose = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { multiCity } = moIndex;
  const { activeList } = moCityStore;
  const { isIndicatorExpired } = moUser;

  useEffect(() => {
    return () => {};
  }, []);

  const onCity = () => {
    if (isIndicatorExpired) toggleTip(true);
    else toggleModal(true);
  };

  return (
    <section className="city-choose_10">
      <b>城市</b>
      <p onClick={onCity}
        className="line-11" aria-hidden="true">
        <span>已选{activeList.length}个城市</span>
        <DownFullIcon color={Color.da} />
      </p>
    </section>
  );
};

export default observer(CityChoose);
